const isPlainObjectOrArray = (
  value: unknown,
): value is Record<string, unknown> | unknown[] =>
  typeof value === "object" && value !== null;

/** Every path, at any depth, whose value is an object or array. */
export const collectBranchPaths = (value: unknown, path: string): string[] => {
  if (!isPlainObjectOrArray(value)) {
    return [];
  }

  const entries = Array.isArray(value)
    ? value.map((item, index) => [String(index), item] as const)
    : Object.entries(value);

  return entries.reduce<string[]>((paths, [key, childValue]) => {
    const childPath = path ? `${path}.${key}` : key;

    if (!isPlainObjectOrArray(childValue)) {
      return paths;
    }

    return [...paths, childPath, ...collectBranchPaths(childValue, childPath)];
  }, []);
};

/**
 * Whether a node should be visible under `filter`. A branch matches when any
 * descendant matches, which `JSON.stringify` gives for free since it already
 * includes every nested value.
 */
export const nodeMatchesFilter = (
  label: string,
  value: unknown,
  filter: string,
): boolean => {
  if (!filter) {
    return true;
  }

  const needle = filter.toLowerCase();

  if (label.toLowerCase().includes(needle)) {
    return true;
  }

  return JSON.stringify(value).toLowerCase().includes(needle);
};

export { isPlainObjectOrArray };
